import {jsx as $9LM7Q$jsx, Fragment as $9LM7Q$Fragment} from "react/jsx-runtime";
import $9LM7Q$react, {forwardRef as $9LM7Q$forwardRef, cloneElement as $9LM7Q$cloneElement, useMemo as $9LM7Q$useMemo, useContext as $9LM7Q$useContext, createContext as $9LM7Q$createContext, useState as $9LM7Q$useState, useRef as $9LM7Q$useRef} from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $2c3357075cb37a67$exports = {};

$parcel$export($2c3357075cb37a67$exports, "RovingIndexItem", () => $0ab5341e18e76faf$export$6fe36eb4fe43155f);
$parcel$export($2c3357075cb37a67$exports, "RovingIndexRoot", () => $968707e23f184d56$export$5b01886ebacd0454);
$parcel$export($2c3357075cb37a67$exports, "useMergeRefs", () => $7803de16a7be6e2c$export$74665b213cb5c4cf);



function $7803de16a7be6e2c$export$74665b213cb5c4cf(refs) {
    return (0, $9LM7Q$useMemo)(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) // eslint-disable-next-line no-param-reassign
                ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}






const $968707e23f184d56$export$887e79ba1a1bc65b = /*#__PURE__*/ (0, $9LM7Q$createContext)({
    elements: {
        current: new Map()
    },
    getOrderedItems: ()=>[],
    setFocusableValue: ()=>{
    /* intentionally empty, will be inherited from RovingIndexRoot */ },
    onShiftTab: ()=>{
    /* intentionally empty, will be inherited from RovingIndexRoot */ },
    focusableValue: null
});
const $968707e23f184d56$export$5b01886ebacd0454 = /*#__PURE__*/ (0, $9LM7Q$forwardRef)(({ valueId: valueId , onBlur: onBlur , onFocus: onFocus , ...rest }, ref)=>{
    const [focusableValue, setFocusableValue] = (0, $9LM7Q$useState)(null);
    const [isShiftTabbing, setIsShiftTabbing] = (0, $9LM7Q$useState)(false);
    const elements = (0, $9LM7Q$useRef)(new Map());
    const myRef = (0, $9LM7Q$useRef)();
    const refs = (0, $7803de16a7be6e2c$export$74665b213cb5c4cf)([
        ref,
        myRef
    ]);
    const getOrderedItems = ()=>{
        if (!myRef.current) return [];
        const elementsFromDOM = Array.from(myRef.current.querySelectorAll("[data-roving-index-item]"));
        return Array.from(elements.current).sort((a, b)=>elementsFromDOM.indexOf(a[1]) - elementsFromDOM.indexOf(b[1])).map(([value, element])=>({
                value: value,
                element: element
            }));
    };
    const rovingIndexContextValue = (0, $9LM7Q$useMemo)(()=>{
        return {
            elements: elements,
            getOrderedItems: getOrderedItems,
            focusableValue: focusableValue,
            setFocusableValue: setFocusableValue,
            onShiftTab: ()=>{
                setIsShiftTabbing(true);
            }
        };
    }, [
        elements,
        focusableValue,
        setFocusableValue
    ]);
    return /*#__PURE__*/ (0, $9LM7Q$jsx)($968707e23f184d56$export$887e79ba1a1bc65b.Provider, {
        value: rovingIndexContextValue,
        children: /*#__PURE__*/ (0, $9LM7Q$jsx)("div", {
            ...rest,
            tabIndex: isShiftTabbing ? -1 : 0,
            onBlur: (e)=>{
                onBlur?.(e);
                setIsShiftTabbing(false);
            },
            onFocus: (e)=>{
                onFocus?.(e);
                if (e.target !== e.currentTarget) return;
                const orderedItems = getOrderedItems();
                if (orderedItems.length === 0) return;
                if (focusableValue != null) elements.current.get(focusableValue)?.focus();
                else if (valueId != null) elements.current.get(valueId)?.focus();
                else orderedItems.at(0)?.element.focus();
            },
            ref: refs
        })
    });
});
$968707e23f184d56$export$5b01886ebacd0454.displayName = "RovingIndexRoot";


const $5e8a981639dfe327$export$b9d40b8c2ff944d8 = (value)=>{
    const { elements: elements , getOrderedItems: getOrderedItems , setFocusableValue: setFocusableValue , focusableValue: focusableValue , onShiftTab: onShiftTab ,  } = (0, $9LM7Q$useContext)((0, $968707e23f184d56$export$887e79ba1a1bc65b));
    return {
        getOrderedItems: getOrderedItems,
        isFocusable: focusableValue === value,
        getRovingProps: (props)=>({
                ...props,
                ref: (element)=>{
                    if (element) elements.current.set(value, element);
                    else elements.current.delete(value);
                },
                onKeyDown: (e)=>{
                    props?.onKeyDown?.(e);
                    if (e.shiftKey && e.key === "Tab") onShiftTab();
                },
                onFocus: (e)=>{
                    props?.onFocus?.(e);
                    setFocusableValue(value);
                },
                "data-roving-index-item": true,
                tabIndex: focusableValue === value ? 0 : -1
            })
    };
};


function $0ab5341e18e76faf$export$17552067ea877de(items, value) {
    const currIndex = items.findIndex((item)=>item.value === value);
    return items.at(currIndex === items.length - 1 ? items.length - 1 : currIndex + 1);
}
function $0ab5341e18e76faf$export$df56b970e0ee6d47(items, value) {
    const currIndex = items.findIndex((item)=>item.value === value);
    return items.at(currIndex === 0 ? 0 : currIndex - 1);
}
const $0ab5341e18e76faf$export$6fe36eb4fe43155f = /*#__PURE__*/ (0, $9LM7Q$forwardRef)(({ value: value , children: children , ...rest }, ref)=>{
    const Component = "div";
    const focusValue = value ?? (typeof children === "string" ? children : "");
    const { getOrderedItems: getOrderedItems , getRovingProps: getRovingProps  } = (0, $5e8a981639dfe327$export$b9d40b8c2ff944d8)(focusValue);
    const rovingProps = getRovingProps({
        onKeyDown: (e)=>{
            rest?.onKeyDown?.(e);
            const items = getOrderedItems();
            let nextItem;
            if (e.key === "ArrowRight") nextItem = $0ab5341e18e76faf$export$17552067ea877de(items, focusValue);
            if (e.key === "ArrowLeft") nextItem = $0ab5341e18e76faf$export$df56b970e0ee6d47(items, focusValue);
            nextItem?.element.focus();
        }
    });
    const mergedRefs = (0, $7803de16a7be6e2c$export$74665b213cb5c4cf)([
        ref,
        rovingProps.ref
    ]);
    if ((0, $9LM7Q$react).Children.count(children) === 1) {
        const child = (0, $9LM7Q$react).Children.toArray(children)[0];
        return /*#__PURE__*/ (0, $9LM7Q$jsx)((0, $9LM7Q$Fragment), {
            children: /*#__PURE__*/ (0, $9LM7Q$cloneElement)(child, {
                ...rest,
                ...rovingProps,
                ref: mergedRefs
            })
        });
    }
    return /*#__PURE__*/ (0, $9LM7Q$jsx)(Component, {
        ...rest,
        ...rovingProps,
        ref: mergedRefs,
        children: children
    });
});
$0ab5341e18e76faf$export$6fe36eb4fe43155f.displayName = "RovingIndexItem";






function $691042682d638bbb$export$61fc7d43ac8f84b0(func, wait = 100) {
    let timeout;
    function debouncedFunc(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debouncedFunc.clear = ()=>{
        clearTimeout(timeout);
    };
    return debouncedFunc;
}




export {$691042682d638bbb$export$61fc7d43ac8f84b0 as debounce, $0ab5341e18e76faf$export$6fe36eb4fe43155f as RovingIndexItem, $968707e23f184d56$export$5b01886ebacd0454 as RovingIndexRoot, $7803de16a7be6e2c$export$74665b213cb5c4cf as useMergeRefs};
//# sourceMappingURL=module.js.map
